export default __webpack_public_path__ + "static/media/logo_servier_new.7b675418.png";